export default {
  title: 'Siirrä verkkosivusto',
  buttons: {
    cancel: 'Peruuta',
    transfer: 'Siirrä',
  },
  fields: {
    target_franchise: {
      label: 'Kohdekonsepti',
      description: 'Valitse konsepti, johon verkkosivusto siirretään',
    },
    sync_companies: {
      label: 'Yritysten yhdistäminen',
      description: 'Yhdistä kohdekonseptin yritykset Storefront-yrityksiin',
      franchise_company: 'Konseptin yritys',
      storefront_company: 'Storefront-yritys',
      select_franchise_company: 'Valitse konseptin yritys',
      select_storefront_company: 'Valitse Storefront-yritys',
      franchise_company_required: 'Konseptin yritys on pakollinen',
      storefront_company_required: 'Storefront-yritys on pakollinen',
    },
  },
  toasts: {
    failed_to_load_companies: 'Yritysten lataaminen epäonnistui',
    no_companies_selected: 'Lisää vähintään yksi yritysyhdistäminen',
    failed_to_transfer: 'Verkkosivuston siirtäminen epäonnistui',
    transfer_success: 'Verkkosivusto siirretty onnistuneesti',
    franchise_already_connected: 'Kohdekonsepti on jo yhdistetty verkkosivustoon',
  },
};
